import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { validationSchema } from "./validationSchema";
import FormItem from "../../../molecules/FormItem/FormItem";
import styled from "styled-components";
import CheckoutHeader from "../../../atoms/CheckoutHeader/CheckoutHeader";
import { PRIMARY } from "../../../../vars/vars";
import AutoCountryHandler from "./AutoCountryHandler";
import ZipCodeHandler from "./ZipCodeHandler";
import OrderSummary from "../../OrderSummary/OrderSummary";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { countries } from "../../../../vars/countries";
import { useAppContext } from "../../../../context/AppContext";

const FormAddress = () => {
  const {
    basketId,
    basket,
    basketOptions,
    setAddress,
    address,
  } = useAppContext();
  const history = useHistory();
  const [checkoutInitiated, setCheckoutInitiated] = useState(false);

  const onSubmit = (values) => {
    setAddress(values);
    history.push("/payment");
  };

  useEffect(() => {
    if (basket && !checkoutInitiated) {
      setCheckoutInitiated(true);
    }
  }, [basket]);

  const initialValues = {
    firstName: (address && address.firstName) || "",
    lastName: (address && address.lastName) || "",
    companyName: (address && address.company) || "",
    email: (address && address && address.email) || "",
    emailSecond: (address && address.email) || "",
    phone: (address && address.phone) || "",
    billing: false,
    company: (address && address.company) || "",
    billaddress: (address && address.billaddress) || "",
    billaddress2: (address && address.billaddress2) || "",
    billcity: (address && address.billcity) || "",
    billzip: (address && address.billzip) || "",
    billcountryname: (address && address.billcountryname) || "",
    isCompany: false,
    vat: "",
    streetAddress: (address && address.streetAddress) || "",
    streetAddress2: (address && address.streetAddress2) || "",
    streetAddress3: (address && address.streetAddress3) || "",
    city: (address && address.city) || "",
    zip: (address && address.zip) || "",
    country:
      (basket && basket.shipcountry) || (address && address.country) || "",
    delivery: (basket && basket.shippingmethod) || "",
    payment: (basket && basket.paymentmethod) || "",
    termsConsent: false,
    basketId: basketId,
  };

  const props = {
    onSubmit,
    initialValues,
    validationSchema,
  };

  return (
    <Formik {...props}>
      {(props) => (
        <Form autoComplete={"off"}>
          <AutoCountryHandler />
          <ZipCodeHandler />
          <CheckoutHeader text={"Dane kontaktowe"} />
          <FormItem required name={"firstName"} label={"Imię"} />
          <FormItem required name={"lastName"} label={"Nazwisko"} />
          <FormItem name={"companyName"} label={"Nazwa firmy (opcjonalnie)"} />
          <FormItem
            required
            type={"email"}
            name={"email"}
            label={"Email"}
            tooltip={"Na ten adres wyślemy potwierdzenie"}
          />
          <FormItem
            required
            type={"email"}
            name={"emailSecond"}
            label={"Potwierdź swój adres email"}
          />
          <FormItem
            required
            name={"phone"}
            type={"tel"}
            label={"Telefon"}
            tooltip={"W razie pytań"}
          />

          <CheckoutHeader text={"Adres dostawy"} />
          <FormItem
            required
            name={"streetAddress"}
            label={"Adres"}
            placeholder={"Ulica"}
          />
          <FormItem required name={"streetAddress2"} placeholder={"Numer"} />
          <FormItem
            name={"streetAddress3"}
            placeholder={"Ciąg dalszy adresu (opcjonalnie)"}
          />
          <FormItem
            required
            name={"city"}
            label={"Miasto"}
            placeholder={"Miasto"}
          />
          <FormItem
            required
            name={"zip"}
            label={"Kod pocztowy"}
            placeholder={"Kod pocztowy"}
          />
          <FormItem
            required
            name={"country"}
            label={"Państwo"}
            placeholder={"Państwo"}
            select
            items={countries.filter((country) => country.iso === "PL")}
          />

          <FormItem checkbox name={"billing"}>
            <Terms>
              Dane rozliczeniowe inne niż adres wysyłki oraz miejsce na numer
              VAT
            </Terms>
          </FormItem>

          {props.values.billing && (
            <div>
              <CheckoutHeader text={"Dane billingowe"} />
              <FormItem
                required
                name={"company"}
                label={"Nazwa firmy"}
                placeholder={"Nazwa firmy"}
              />
              <FormItem
                required
                name={"billaddress"}
                label={"Adres"}
                placeholder="Ulica i numer"
              />
              <FormItem
                name={"billaddress2"}
                placeholder={"Ciąg dalszy adresu (opcjonalnie)"}
              />
              <FormItem
                required
                name={"billcity"}
                label={"Miasto"}
                placeholder={"Miasto"}
              />
              <FormItem
                required
                name={"billzip"}
                label={"Kod pocztowy"}
                placeholder={"Kod pocztowy"}
              />
              <FormItem
                required
                name={"billcountryname"}
                label={"Państwo"}
                select
                items={countries.filter((country) => country.iso === "PL")}
              />
              <FormItem checkbox name={"isCompany"}>
                <Terms>
                  Chcę dokonać zakupu jako klient B2B z aktywnym numerem VAT
                </Terms>
              </FormItem>
              {props.values.isCompany && (
                <FormItem required name={"vat"} label={"Numer NIP"}></FormItem>
              )}
            </div>
          )}

          <CheckoutHeader text={"Sposób dostawy"} />
          {basketOptions &&
          basketOptions.shippingmethod &&
          basketOptions.shippingmethod.length ? (
            <FormItem
              required
              name={"delivery"}
              label={"Sposób dostawy"}
              select
              items={basketOptions.shippingmethod.map((method) => ({
                iso: method._id,
                name:
                  method.displayname === method.description
                    ? method.displayname
                    : `${method.displayname} - ${method.description}`,
              }))}
            />
          ) : null}
          <CheckoutHeader text={"Sposób płatności"} />
          {basketOptions &&
          basketOptions.paymentmethod &&
          basketOptions.paymentmethod.length ? (
            <FormItem
              required
              name={"payment"}
              label={"Wybór płatności"}
              select
              items={basketOptions.paymentmethod.map((method) => ({
                iso: method._id,
                name: method.displayname || method.name,
              }))}
            />
          ) : null}
          <FormItem required checkbox name={"termsConsent"}>
            <Terms required>
              Akceptuję{" "}
              <Link to={"/terms"} className="gtm_btn_termsandconditions">
                Warunki i zobowiązania
              </Link>
            </Terms>
          </FormItem>
          <OrderWrapper>
            <OrderSummary header={"Podsumowanie"} />
          </OrderWrapper>
          <ButtonWrapper>
            <Button type={"submit"}>Dalej</Button>
          </ButtonWrapper>
        </Form>
      )}
    </Formik>
  );
};

export default FormAddress;

const ButtonWrapper = styled.div`
  max-width: 600px;
  display: flex;
  justify-content: flex-end;
`;

const OrderWrapper = styled.div`
  @media screen and (min-width: 1000px) {
    display: none;
  }
`;

const Terms = styled.div`
  &:after {
    content: "*";
    color: ${PRIMARY};
    display: ${(props) => (props.required ? "inline-block" : "none")};
  }
`;

const Button = styled.button`
  margin-top: 50px;
  color: white;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  outline: none;
  border: none;
  background-color: #444;
  cursor: pointer;
  height: 35px;
  text-transform: uppercase;
  font-weight: 400;
  padding: 0 20px;
  width: 100%;

  &:hover {
    background-color: ${PRIMARY};
  }

  @media screen and (min-width: 768px) {
    width: auto;
  }
`;
